import { createContext } from 'react'
import { Dictionaries } from 'core/dictionaries/types'

export type DictionariesContextType = {
  dictionaries?: Dictionaries
}

const DictionariesContext = createContext<DictionariesContextType>({})

export default DictionariesContext
